import Repository from "../../repository";

export default {
    UploadBase64Strings: (payload) => Repository.post(`/api/StationImages/UploadBase64Strings`, payload),
    GetByID: (payload) => Repository.post(`/api/StationImages/GetByID`, payload),
}